// removed by extract-text-webpack-plugin
module.exports = {"avatar":"avatar__1C3r3","image":"image__1izFW","letter":"letter__hkoQC"};


//////////////////
// WEBPACK FOOTER
// ../~/react-toolbox/lib/avatar/theme.css
// module id = 3qQ2
// module chunks = 6